<template>
    <facet-template
        :show-clear-link="isFiltered"
        :title="title"
        class="body-styles-facet"
        v-bind="$attrs"
        @clear="clearSelectedBodyStyles"
    >
      <span slot="facetLabel">
            {{ title }}
            <small class="font-italic font-weight-normal" v-if="value.length>0">
                ({{ value.length }})
            </small>
        </span>
        <div class="d-flex flex-wrap">
            <div
                v-for="bodyStyle in validBodyStyles"
                :id="bodyStyle.id"
                :key="bodyStyle.id"
                class="text-center mb-2 body-style"
            >
                <!-- selected style is based on applied filters in vuex. -->
                <div
                    class="body-style-wrapper mb-3"
                    :class="
                        bodyStyle.name === 'suv'
                            ? 'text-uppercase'
                            : 'text-capitalize'
                    "
                    @click="toggleBodyStyle(bodyStyle)"
                >
                    <div class="body-style-icon">
                        <body-style-icon
                            :body-style="bodyStyle.id"
                            :selected="bodyStyleSelected(bodyStyle)"
                        />
                    </div>
                    <small>{{ bodyStyle.name }}</small>
                </div>
            </div>
        </div>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";
import BodyStyleIcon from "@carsaver/body-style-icon";
import _ from "lodash";

export default {
    components: {
        BodyStyleIcon,
        FacetTemplate
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        available: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: "Body Style"
        }
    },

    computed: {
        validBodyStyles() {
            return _.filter(this.available, bodyStyle => {
                return bodyStyle != null;
            });
        },
        isFiltered() {
            return !_.isEmpty(this.value);
        }
    },
    methods: {
        clearSelectedBodyStyles() {
            this.$emit("input", []);
        },
        toggleBodyStyle(clickedBodyStyle) {
            const userIsAddingBodyStyleFilter =
                this.value.indexOf(clickedBodyStyle.id) === -1;

            if (userIsAddingBodyStyleFilter) {
                this.$emit("input", this.value.concat(clickedBodyStyle.id));
            } else {
                this.$emit(
                    "input",
                    this.value.filter(
                        bStyleId => bStyleId !== clickedBodyStyle.id
                    )
                );
            }
        },
        bodyStyleSelected(bodyStyle) {
            return this.value.indexOf(bodyStyle.id) > -1;
        }
    }
};
</script>
<style lang="scss">
.body-styles-facet {
    .facet-body {
        margin-top: 26px !important;
        margin-bottom: 0 !important;
    }

    .body-style {
        width: 50%;

        @media (max-width: 576px) {
            width: 33%;
        }
    }

    .body-style-wrapper {
        cursor: pointer;

        .body-style-icon {
            height: 30px;

            i {
                font-size: 25px;
            }

            @media (max-width: 768px) {
                i {
                    font-size: 20px;
                    line-height: 30px;
                    vertical-align: bottom;
                }
            }
        }
    }
}
</style>
